import type { PublicProductSummary } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { ProductCard } from '@/entities/product';

interface ProductCardGridProps {
  readonly products: readonly PublicProductSummary[];
}

/** 상품 카드 진열 — 1열(기본)·sm 2열·lg 4열. 카드 사이 가로는 좁게, 줄 사이는 넓게 띄운다(HOME 추천과 같은 리듬). */
export const ProductCardGrid = ({ products }: ProductCardGridProps): ReactElement => (
  <ul className="grid gap-x-4 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
    {products.map((product) => (
      <li key={product.id}>
        <ProductCard product={product} />
      </li>
    ))}
  </ul>
);
